var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DropdownReducerActionTypes } from '../types/DropdownReducerActionTypes';
import { DropdownStates } from '../types/DropdownStates';
import { appendDropdownOptionToEnd } from './appendDropdownOptionToEnd';
import { getHighlightedIndex } from './getHighlightedIndex';
import { KEY_CODES } from '../../../common/types/keyCodes';
/**
 * The dropdown reducer. This holds the entire state of the dropdown
 *
 * @param {DropdownReducerState} state
 * @param {DropdownReducerAction} { type, payload }
 * @return {*}  {DropdownReducerState}
 */
export var dropdownReducer = function (state, _a) {
    var _b;
    var type = _a.type, payload = _a.payload;
    switch (type) {
        case DropdownReducerActionTypes.SelectOption:
            return __assign(__assign({}, state), { dropdownState: state.dropdownState === DropdownStates.LOCKED ? DropdownStates.LOCKED : DropdownStates.LIST_CLOSED, selectedDropdownOption: (_b = payload.selectedDropdownOption) !== null && _b !== void 0 ? _b : state.selectedDropdownOption, dropdownOptions: appendDropdownOptionToEnd(payload.selectedDropdownOption)(state.dropdownOptions) });
        case DropdownReducerActionTypes.ClearOption:
            return __assign(__assign({}, state), { selectedDropdownOption: null });
        case DropdownReducerActionTypes.Searching:
            return __assign(__assign({}, state), { dropdownState: DropdownStates.SEARCHING, highlightedOptionIndex: null });
        case DropdownReducerActionTypes.SearchResolved:
            return __assign(__assign({}, state), { dropdownState: DropdownStates.LIST_OPEN, dropdownOptions: appendDropdownOptionToEnd(state.selectedDropdownOption)(payload.dropdownOptions), highlightedOptionIndex: payload.dropdownOptions.length ? 0 : null });
        case DropdownReducerActionTypes.CloseList:
            return __assign(__assign({}, state), { dropdownState: state.dropdownState === DropdownStates.LOCKED ? DropdownStates.LOCKED : DropdownStates.LIST_CLOSED, highlightedOptionIndex: null });
        case DropdownReducerActionTypes.NavigateList:
            return __assign(__assign({}, state), { highlightedOptionIndex: getHighlightedIndex(state.highlightedOptionIndex + (payload.key === KEY_CODES.ARROW_DOWN.key ? 1 : -1), state.dropdownOptions.length) });
        case DropdownReducerActionTypes.SetHighlightedOptionIndex:
            return __assign(__assign({}, state), { highlightedOptionIndex: payload.highlightedOptionIndex });
        default:
            return state;
    }
};
//# sourceMappingURL=dropdownReducer.js.map